import React from 'react';
import {useTranslation} from "react-i18next";

function MobileMenu({toggleMenu}) {
    const { t } = useTranslation()
    return (
        <div className="mobile-menu">
            <div className="mobile-menu__nav">
                <a href="#" className='header__link' onClick={toggleMenu}>{t('header.link.about')}</a>
                <a href="#" className='header__link' onClick={toggleMenu}>{t('header.link.price')}</a>
                <a href="#" className='header__link' onClick={toggleMenu}>
                    {t('header.link.information')}
                </a>
                <a href="#" className='header__link' onClick={toggleMenu}>
                    {t('header.link.trade_view')}
                </a>
                <a href="#" className='header__link' onClick={toggleMenu}>
                    {t('header.link.contact_us')}
                </a>
            </div>

            <div className="mobile-menu__buttons">
                <a href={process.env.REACT_APP_LOGIN_LINK || "#"} rel="noreferrer"  target="_blank" className='button button--transparent'>
                    {t('header.button.login')}
                </a>
                <a href={process.env.REACT_APP_REGISTER_LINK || "#"} rel="noreferrer"  target="_blank" className='button '>
                    {t('header.button.register')}
                </a>
            </div>
        </div>
    );
}

export default MobileMenu;